module.exports = __webpack_public_path__ + "static/img/t3.91ec26e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexactivity/t3.png
// module id = slwc
// module chunks = 3